import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';

export interface PublishDialogData {
  bookmark: BookmarkModel;
}

@Component({
  selector: 'app-publish-dialog',
  templateUrl: './publish-dialog.component.html',
  styleUrls: ['./publish-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublishDialogComponent implements OnInit {
  bookmark: BookmarkModel;

  constructor(
    private dialogRef: MatDialogRef<PublishDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: PublishDialogData
  ) {
    this.bookmark = data.bookmark;
  }

  ngOnInit() {
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
